import { gql } from '@apollo/client';

export const UpdateLearnMoreRequested = gql`
  mutation UpdateLearnMoreRequested {
    buyer {
      updateUserLearnMoreRequested(input: { learnMoreRequested: true }) {
        user {
          learnMoreRequested
        }
      }
    }
  }
`;
